 // 配置
 const aaa = [
    // 门店预约 预约排班  预约配置
     
 {
    path: "yuyuePeiZhi",
    component: () => import("@/views/ximeiyuyue/yuyuePeiZhi/list.vue"),
    meta: { title: "预约配置" },
  },
  {
    path: "yuyuePeiZhiAdd",
    component: () => import("@/views/ximeiyuyue/yuyuePeiZhi/add.vue"),
    meta: { title: "预约配置" },
  },
  {
    path: "yuyuePeiZhiEdit",
    component: () => import("@/views/ximeiyuyue/yuyuePeiZhi/edit.vue"),
    meta: { title: "预约配置" },
  }
  ];
  export default aaa;
